import React, { useState } from "react";
import "./FAQ.css";

export default function FAQ() {
  const [openIndexes, setOpenIndexes] = useState([]);

  const faqItems = [
    {
      question: "Можно ли заказать гибку, если соединение внахлест, а не встык?",
      answer:
        "Да, но нам нужно это знать заранее — на расчёт и на допуски это влияет",
    },
    {
      question: "Делаете ли вы гибку из нашего материала, если мы привезём листы?",
      answer:
        "Да, но только после того, как проверим пригодность металла и чертежей под наш инструмент.",
    },
    {
      question: "Какие виды металлов можно резать лазером?",
      answer:
        "Лазерная резка подходит для работы с черным, цветным и нержавеющим металлом. Мы также выполняем раскрой тонколистового и толстого металла до 20 мм.",
    },
    {
      question: "Можно ли заказать срочную лазерную резку металла?",
      answer:
        "Да, мы предоставляем услуги срочной лазерной резки. Время выполнения заказа начинается от 1 рабочего дня, в зависимости от объема и сложности проекта.",
    },
    {
      question: "Можно ли заказать порошковую окраску изделий с фактурой (шагрень, муар, антик)?",
      answer:
        "Да, мы выполняем полимерную окраску с разными фактурами поверхности — шагрень, муар, антик, полумат и другие. Расскажите, какой эффект вам нужен, и мы подберем оптимальный вариант.",
    },
    {
      question: "Можно ли выполнить покраску декоративных или профильных изделий?",
      answer:
        "Да, мы красим профильные изделия, декоративные элементы, мебель, радиаторы, сетки и другие сложные по геометрии объекты.",
    },
    {
      question: "Как оформить заявку на товар/услугу?",
      answer:
        "Заявку в можно оформить по электронной почте xarmet@inbox.ru либо по телефону: +7(952)350-43-16",
    },
  ];

  const toggleItem = (index) => {
    setOpenIndexes((prev) =>
      prev.includes(index) ? prev.filter((i) => i !== index) : [...prev, index]
    );
  };

  return (
    <section id="faq" className="faq-section">
      <h2 className="faq-title">Часто задаваемые вопросы</h2>

      <div className="faq-list">
        {faqItems.map((item, index) => {
          const isOpen = openIndexes.includes(index);

          return (
            <div key={index} className="faq-item" aria-expanded={isOpen}>
              <button
                className="faq-toggle"
                onClick={() => toggleItem(index)}
                aria-expanded={isOpen}
                type="button"
              >
                <span
                  className={`faq-toggle-icon ${
                    isOpen ? "faq-toggle-icon-down" : ""
                  }`}
                >
                  &gt;
                </span>
              </button>

              <div className="faq-content">
                <div className="faq-question-row">
                  <span className="faq-question-text">{item.question}</span>
                </div>

                <div className="faq-answer-wrapper">
                  <div className="faq-answer">
                    <div className="faq-answer-line"></div>
                    <p>{item.answer}</p>
                  </div>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </section>
  );
}